import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../common/components/base.component';
import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';
import { catchError, of, map, finalize } from 'rxjs';
import { Message } from '../../../common/enums/message.enum';
import { OrderRoutes } from '../../orders/orders-routes.enum';

@Component({
  selector: 'app-lic-auth',
  standalone: false,
  templateUrl: './lic-auth.component.html',
  styleUrl: './lic-auth.component.scss'
})
export class LicAuthComponent extends BaseComponent implements OnInit {

  ngOnInit() {
    this.spinnerService.setLoading(true, 'lic-auth-spinner')
    this.subscriptions.add(this.handleLICProcess().pipe(finalize(() => {
      this.spinnerService.setLoading(false, 'lic-auth-spinner');
    })).subscribe());
  }

  handleLICProcess() {
    const launch$ = this.launchAuthRedirectService.handlePendingLaunchId()
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.warn('Launch ID could not be processed after login', error)
          if (error.status === 409) {
            this.notificationService.showError(Message.LaunchInContextConflictProcessErrorMessage);
          } else {
            this.notificationService.showError(Message.LaunchInContextProcessErrorMessage)
          }
          return of(-1)
        }),
        map((handled) => {
          let route: string = OrderRoutes.WELCOME;
          if (handled == 1) {
            route = OrderRoutes.ORDER_SETUP
          } else if (handled == 2) {
            route = OrderRoutes.SERVICE_INFORMATION
          }
          return this.router.navigate([route])
        }))

    return launch$;
  }
}
